import { Stack, StackChildren, Text } from '@doordash/design-language'
import * as React from 'react'

export const enum InfoTextFieldSizes {
  Small,
  Medium,
  Large,
}

const SizeSemantics = {
  [InfoTextFieldSizes.Small]: 'FieldSmall',
  [InfoTextFieldSizes.Medium]: 'FieldMedium',
  [InfoTextFieldSizes.Large]: 'FieldLarge',
}

interface InfoTextFieldProps {
  label: string
  value: string
  size?: InfoTextFieldSizes
}

/**
 * A non-editable text field that does not render an input box
 */
export const InfoTextField: React.FC<InfoTextFieldProps> = ({
  label,
  value,
  size = InfoTextFieldSizes.Medium,
}) => {
  return (
    <StackChildren size={Stack.Sizes.XxSmall}>
      <Text styles={Text.Styles[`${SizeSemantics[size]}Label`]}>{label}</Text>
      <Text styles={Text.Styles[`${SizeSemantics[size]}Input`]}>{value}</Text>
    </StackChildren>
  )
}
